import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import * as styles from './separator.module.css';

export const FormSeparator = ({ text = 'or use', loose, withArrow, withLine = true, bold, dark = false }) => {
  return (
    <div
      className={classnames(styles.separator, loose && styles.separatorLoose, bold && styles.separatorBold, dark && styles.separatorDark)}
    >
      <div className={styles.separatorText}>{text}</div>
      {withLine && (
        <>
          <div className={styles.separatorCircle}></div>
          <div className={styles.separatorLine}></div>
          {withArrow && <div className={styles.separatorArrow}></div>}
        </>
      )}
    </div>
  );
};

FormSeparator.propTypes = {
  text: PropTypes.string,
};
